import log from 'loglevel'
import { SolidPolygonLayer } from '@deck.gl/layers'

// レイヤーID
const LAYER_ID = 'backdrop'

// データ
const DATA = [
  {
    polygon: [
      [-180, -90],
      [-180, 90],
      [180, 90],
      [180, -90],
      [-180, -90],
    ],
  },
]

/**
 * バックドロップのレンダラー
 */
class BackdropRenderer {
  /**
   * コンストラクタ
   */
  constructor() {
    this.data = DATA
  }

  /**
   * レンダラー関数を作成する
   * @param {Object} param 描画パラメータ
   * @returns {Object} レンダラー {id: String, render: Function.<SolidPolygonLayer>}
   */
  createRenderer(param) {
    log.debug('[DEBUG] start render backdrop', param)
    const visible =
      typeof param.visible === 'boolean'
        ? param.visible
        : Object.values(param.visible).some((v) => v)

    return {
      id: LAYER_ID,
      render: () =>
        new SolidPolygonLayer({
          id: LAYER_ID,
          data: this.data,
          visible,
          pickable: param.style.pickable || false,
          getFillColor: param.style.fillColor || [51, 51, 51, 51],
          parameters: {
            depthTest: false,
            blend: true,
          },
        }),
    }
  }
}

BackdropRenderer.LAYER_ID = LAYER_ID

export default BackdropRenderer
